//Back-end server
export const IP_BE = process.env.REACT_APP_IB_BE_URL;
//S3 bucket api
// export const IP = "http://b4spublic.s3-website.ap-south-1.amazonaws.com/";
// export const IP = "https://dxs5if5qoy7z5.cloudfront.net/";
export const IP = process.env.REACT_APP_PUBLIC_URL;
// export const IP = "http://localhost:3002";
